import { getSheet } from '../sheet-overlay.js';

const SHEET_ID = 'js-energy-efficiency-sheet';

export function initEnergyEfficiency() {
  if (window.energyEfficiencyInitialized) {
    return;
  }
  window.energyEfficiencyInitialized = true;

  document.addEventListener(
    'click',
    function (event) {
      const labelFicheLink = event.target.closest('.js_energy_efficiency_label_fiche_link');
      if (labelFicheLink) {
        event.stopPropagation();
        return;
      }

      const button = event.target.closest('.js_energy_efficiency_button');
      if (!button) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();

      const sheet = getSheet(SHEET_ID);
      if (sheet === null) {
        return;
      }

      sheet.querySelector('.js_energy_efficiency_image').src = button.dataset.energyLabelUrl;

      const productFicheUrl = button.dataset.productFicheUrl ?? '';
      const ficheLink = sheet.querySelector('.js_energy_efficiency_fiche_link');
      ficheLink.href = productFicheUrl;
      ficheLink.classList.toggle('hidden', productFicheUrl === '');

      sheet.open();
    },
    true,
  );
}

initEnergyEfficiency();
